import { createLoadWithPaginationAdapter } from '../../ngrx-helpers/adapters/load-with-pagination/adapter';
import { ViewNotificationReceipt } from 'studio-components';

export const NotificationReceiptKey = 'notification-receipt';
export const Type = 'Notification Receipt';
export const notificationReceiptLoadAdapter =
  createLoadWithPaginationAdapter<ViewNotificationReceipt>({
    stateKey: NotificationReceiptKey,
    type: Type,
  });
